module.exports = __webpack_public_path__ + "static/media/Client_Services_Agreement_FSA.2757f7a1.pdf";